import { CONFIG } from "config";

export const API_PATHS = {
  OAUTH_LOGIN: (provider) => `${CONFIG.BACKEND_ORIGIN}/api/v1/auth/oauth/login/${provider}/`,
  OAUTH_REGISTER: (provider) => `${CONFIG.BACKEND_ORIGIN}/api/v1/auth/oauth/register/${provider}/`,
};